import tableRelatedCEVods from './tableRelatedCEVoDs';

export default {
  title: 'List of successful Vods',
  attributeName: 'vods',
  getURL: 'getAllVodSuccess',
  // getDataPostUrl: 'vodcomposeexperienceList',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: [],
  tableConfig: tableRelatedCEVods,
  dialogClassName:'modal-80vw',
};
